import type { CategoryMeta } from "@/types/content";

export const categories: CategoryMeta[] = [
  {
    key: "drama",
    name: "剧情",
    en: "Drama",
    short: "以人物与命运为核心的作品",
    description:
      "剧情向作品更在意人物关系和时代气息，镜头语言克制、叙事绵长，适合慢慢看完之后再回味一遍的类型。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20landscape%20still%20of%20a%20misty%20seaside%20town%20rooftop%20at%20dawn%2C%20muted%20warm%20tones%2C%20soft%20haze%2C%20analog%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=800&height=600&seq=cat-drama&orientation=landscape",
  },
  {
    key: "romance",
    name: "爱情",
    en: "Romance",
    short: "关于相遇、错过与和解",
    description:
      "爱情类型常常把故事放在狭窄的房间里发生，靠光线、语气和沉默推进情绪，是本站收藏最完整的一类。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20landscape%20still%20of%20sheer%20curtains%20and%20warm%20sunset%20light%20falling%20on%20an%20empty%20room%2C%20soft%20golden%20haze%2C%20analog%20film%20grain%2C%20no%20text&width=800&height=600&seq=cat-romance&orientation=landscape",
  },
  {
    key: "crime",
    name: "犯罪",
    en: "Crime",
    short: "夜色、规则与灰色地带",
    description:
      "犯罪题材是九十年代港产类型片的代表方向，潮湿街道、霓虹灯和人物之间暧昧的道德边界，构成了它的标志性气质。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20landscape%20still%20of%20rainy%20night%20alley%20with%20amber%20lamp%20and%20wet%20asphalt%20reflections%2C%20noir%20mood%2C%20film%20grain%2C%20no%20text&width=800&height=600&seq=cat-crime&orientation=landscape",
  },
  {
    key: "mystery",
    name: "悬疑",
    en: "Mystery",
    short: "线索藏在细节里",
    description:
      "悬疑类型的乐趣在于信息差：镜头里出现的每一个物件都可能成为线索，二刷时常常会看到完全不同的故事。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20landscape%20still%20of%20dim%20corridor%20with%20a%20single%20door%20and%20drifting%20haze%2C%20deep%20shadows%2C%20dramatic%20lighting%2C%20film%20grain%2C%20no%20text&width=800&height=600&seq=cat-mystery&orientation=landscape",
  },
  {
    key: "urban",
    name: "都市",
    en: "Urban",
    short: "城市里的夜晚与人群",
    description:
      "都市类型把镜头对准写字楼、便利店、出租车与天台，记录城市在深夜里的另一幅面孔，节奏轻快、生活感强。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20landscape%20still%20of%20city%20skyline%20at%20dusk%20with%20warm%20window%20lights%20and%20violet%20sky%2C%20atmospheric%20haze%2C%20film%20grain%2C%20no%20text&width=800&height=600&seq=cat-urban&orientation=landscape",
  },
];